export const FEEDBACK_COOLDOWN_MS = 24 * 60 * 60 * 1000;
export const FEEDBACK_COOLDOWN_EVENT = 'hv-product-feedback-hidden';

type FeedbackUser = {
  id?: unknown;
  _id?: unknown;
  role?: string | null;
} | null | undefined;

export function feedbackStorageKey(userId: string): string {
  return `hv-product-feedback-at:${userId}`;
}

export function feedbackUserId(user: FeedbackUser): string | null {
  if (!user || user.role === 'guest') return null;
  const id = user.id ?? user._id;
  if (id == null || id === '') return null;
  return String(id);
}

export function isFeedbackOnCooldown(userId: string, now = Date.now()): boolean {
  try {
    const at = Number(localStorage.getItem(feedbackStorageKey(userId)));
    return Number.isFinite(at) && now - at < FEEDBACK_COOLDOWN_MS;
  } catch {
    return false;
  }
}

export function markFeedbackSubmitted(userId: string, now = Date.now()): void {
  localStorage.setItem(feedbackStorageKey(userId), String(now));
  window.dispatchEvent(new Event(FEEDBACK_COOLDOWN_EVENT));
}
